import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { StanToggle } from '@/components';
import { FlowStepProps } from '../../../types/addFlow.types';
import { ProductSelector } from '../../ProductSelector';
import { FLOW_TRIGGER } from '../../../constants/flowTriggers';

interface ProductSelectionStepProps extends FlowStepProps {
    selectedTrigger: string;
}

export const ProductSelectionStep = ({ control, errors, selectedTrigger }: ProductSelectionStepProps) => {
    const [showRemoveRecipients, setShowRemoveRecipients] = useState(false);
    const isCartAbandonmentTrigger = selectedTrigger === FLOW_TRIGGER.CART_ABANDONMENT;

    return (
        <div className='mb-6 flex w-full flex-col gap-6 sm:mb-8 sm:gap-8'>
            <h3>Choose your product</h3>
            <div className='flex flex-col gap-4'>
                <Controller
                    name='selectedProducts'
                    control={control}
                    render={({ field }) => (
                        <ProductSelector
                            selectedProductIds={field.value || [0]}
                            onProductsChange={field.onChange}
                            onlyPaidProducts={isCartAbandonmentTrigger}
                            error={!!errors.selectedProducts}
                            hintText={errors.selectedProducts?.message}
                        />
                    )}
                />

                {!isCartAbandonmentTrigger && (
                    <>
                        <div className='flex items-center gap-2'>
                            <StanToggle
                                checked={showRemoveRecipients}
                                onChange={e => setShowRemoveRecipients(e.target.checked)}
                                toggleSize='sm'
                            />
                            <label className='text-dark text-xs font-medium'>
                                Remove customer from flow after product purchase
                            </label>
                        </div>

                        {showRemoveRecipients && (
                            <Controller
                                name='selectedExcludeProducts'
                                control={control}
                                render={({ field }) => (
                                    <ProductSelector
                                        selectedProductIds={field.value || []}
                                        onProductsChange={field.onChange}
                                        includeAllProductsTag={false}
                                        includeNewReferralTag={false}
                                        label='Exclude Products'
                                        placeholder='Select products to exclude...'
                                    />
                                )}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
